import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollPositions = new Map<string, number>();

export function ViewportManager() {
  const location = useLocation();

  useEffect(() => {
    const viewport = window.visualViewport;
    const updateViewport = () => {
      const height = viewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty("--app-height", `${height}px`);
    };
    updateViewport();
    viewport?.addEventListener("resize", updateViewport);
    viewport?.addEventListener("scroll", updateViewport);
    window.addEventListener("resize", updateViewport);
    return () => {
      viewport?.removeEventListener("resize", updateViewport);
      viewport?.removeEventListener("scroll", updateViewport);
      window.removeEventListener("resize", updateViewport);
    };
  }, []);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    const frame = window.requestAnimationFrame(() => window.scrollTo({ top: scrollPositions.get(key) ?? 0 }));
    return () => {
      window.cancelAnimationFrame(frame);
      scrollPositions.set(key, window.scrollY);
    };
  }, [location.pathname, location.search]);

  return null;
}
